<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>运维服务</el-breadcrumb-item>
        <el-breadcrumb-item>软件版本</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="10">
                <!-- 机器名查询 -->
                <el-col :span="7" >
                    <span>版本号:</span>
                    <el-input placeholder="请输入版本号" v-model="robotversion.version" class="m-l-30 ell-input" ></el-input>
                </el-col>
                <el-col :span="7" >
                    <span>硬件编号:</span>
                    <el-input placeholder="请输入编号" v-model="robotversion.hardwareNo" class="m-l-30 ell-input" ></el-input>
                </el-col>
               
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
        
            <el-col align="middle" >
                <el-button type="primary" @click="searchRobotversion()">查询</el-button>
                <el-button type="primary" @click="addRobotversionDialog()">添加</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="robotversionList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="版本号" prop="version" width="250"></el-table-column>
            <el-table-column label="硬件编号" prop="hardwareNo" width="250"></el-table-column>
            <el-table-column label="备注" prop="remake" width="250"></el-table-column>
            <el-table-column label="文件路径"  width="150">
                 <template   slot-scope="scope">
                   <a :href="path+scope.row.versionUrl" target="_blank" class="buttonText">软件下载</a>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="150"></el-table-column>
            <el-table-column label="操作" prop="" width="200">
                <template slot-scope="scope">
                     <!-- 编辑按钮 -->
                    <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false"  >
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)"></el-button>
                    </el-tooltip>
                    <!-- 删除按钮 -->
                    <el-tooltip effect="dark" content="删除" placement="top" :enterable="false"  >  
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row.id)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="robotversion.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
         <!-- 添加设备对话框 -->
        <el-dialog title="添加版本"  :visible.sync="addRobotversionVisible"  width="50%" @close="robotversionClose">
                <!-- 内容主题主区 -->
            <el-form ref="addRobotversionRef" :model="addRobotversion"  :rules="addRobotversionRules" label-width="70px">
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="版本号:"  label-width="25" prop="version" >
                            <el-input v-model="addRobotversion.version" disabled ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="硬件编号:"  label-width="25" prop="hardwareNo">
                            <el-select v-model="addRobotversion.hardwareNo" placeholder="硬件编号" style="width:60%" class="m-l-10">
                                    <el-option v-for="item in hardwareNoLists" :key="item.id" :label="item.hardwareNo" :value="item.hardwareNo"   />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="60"  >
                     <el-col :span="9" >
                         <input id="fileupload"  accept=".zip"  class="change" type="file" multiple="multiple" @change="getFile($event,'file_avatar','add')"/>
                    </el-col>
                    <el-col :span="14" >
                        <el-form-item label="备注信息:"  label-width="25"  prop="remake" >
                            <el-input v-model="addRobotversion.remake"  autosize  type="textarea" style="width:50%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
            </el-form>
                <!-- 底部区 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="addRobotversionVisible = false">取 消</el-button>
                <el-button type="primary" @click="addRobotversionData()">确 定</el-button>
            </span>
        </el-dialog>
         <!-- 添加设备对话框 -->
        <el-dialog title="修改版本"  :visible.sync="updateRobotversionVisible"  width="50%" @close="updaterobotversionClose">
                <!-- 内容主题主区 -->
            <el-form ref="updateRobotversionRef" :model="updateRobotversion"  :rules="updateRobotversionRules" label-width="70px">
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="版本号:"  label-width="25" prop="version">
                            <el-input v-model="updateRobotversion.version" disabled class="m-l-10"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" >
                        <el-form-item label="硬件编号:"  label-width="25" prop="hardwareNo">
                            <el-select v-model="updateRobotversion.hardwareNo" placeholder="硬件编号" style="width:60%" class="m-l-10">
                                    <el-option v-for="item in hardwareNoLists" :key="item.id" :label="item.hardwareNo" :value="item.hardwareNo"   />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="60"  >
                     <el-col :span="9" >
                         <input id="upfileupload" class="change" type="file" multiple="multiple"  accept=".zip"   @change="getFile($event,'file_avatar','edit')"/>
                    </el-col>
                     <el-col :span="14" >
                        <el-form-item label="备注信息:"  label-width="25"  prop="remake" >
                            <el-input v-model="updateRobotversion.remake"  type="textarea" style="width:50%"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 上传进度条  -->
           
                <!-- 底部区 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateRobotversionVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateRobotversionData()">确 定</el-button>
            </span>
        </el-dialog>
         <el-dialog title="上传中"  :visible.sync="dialogProgressVisible" class="taskdialog" @close="progressDialogClose"  >
                <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" :status="progressStatus"></el-progress>
        </el-dialog>
    </el-card >
  </div>
</template>

<script>


export default {
  name: 'machine',
  data(){
     var checkZF=(rule,value,cb)=>{
            var zF = /[`~!@#$%^&*()\+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘'，。、]/
            if(!zF.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
      }
      var checkHardwareNo=(rule,value,cb)=>{
            const  regHardwareNo=/^[0-9a-zA-Z]*$/
            if(regHardwareNo.test(value)){
                return cb();
            }
            cb(new Error('请输入数字或字母!'))
      }
      return {
          robotversion :{
              version:'',
              hardwareNo:'',
              num : 1
          },
          addRobotversion:{
            version:'',
            hardwareNo:'',
            remake:'',
          },
          
          addRobotversionVisible:false,
          updateRobotversionVisible:false,
          total:0,
          addRobotversionRules:{
            version:[{required: true, message: '请输入版本号!',  trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
            hardwareNo:[{required: true, message: '请输入硬件编号!',  trigger: 'blur' },{ min: 2,  max: 16,  message: '长度在 2 到 16 个字符!',   trigger: 'blur' },{ validator : checkHardwareNo, trigger: 'blur'}],
            remake:[{required: true, message: '请输入备注信息!',  trigger: 'blur' },{ min: 2,  max: 200,  message: '长度在 2 到 200 个字符!',   trigger: 'blur' }],
          },
          updateRobotversionRules:{
            version:[{required: true, message: '请输入版本号!',  trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
            hardwareNo:[{required: true, message: '请输入硬件编号!',  trigger: 'blur' },{ min: 2,  max: 16,  message: '长度在 2 到 16 个字符!',   trigger: 'blur' },{ validator : checkHardwareNo, trigger: 'blur'}],
            remake:[{required: true, message: '请输入备注信息!',  trigger: 'blur' },{ min: 2,  max: 200,  message: '长度在 2 到 200 个字符!',   trigger: 'blur' }],
          },
          path:'',
          robotversionList:[],
          formData:new FormData(),
          updateRobotversion:{},
          dialogProgressVisible:false,
          percentage:0,
          timer:null,
          progressStatus:null,
          hardwareNoLists:[],
          updateLoadFlag : false
      }
  },
   //生命周期函数
  created(){
    this.searchRobotversion()
  },
  methods:{
        
        progressDialogClose(){
            this.dialogProgressVisible=false
            this.percentage=0
            clearInterval(this.timer);
        },
        updateRobotversionData(){
            // if(this.updateRobotversion.version==undefined || this.addRobotversion.version===""){
            //       return this.$message.error('版本号为空!')
            // }
            console.log(this.updateRobotversion)
            if(this.updateRobotversion.hardwareNo=== undefined || this.updateRobotversion.hardwareNo===""){
                  return this.$message.error('硬件编号为空!')
            }
            if(this.updateRobotversion.remake==undefined || this.updateRobotversion.remake===""){
                  return this.$message.error('备注信息为空!')
            }
            this.formData.append("id",this.updateRobotversion.id)
            //this.formData.append("version",this.updateRobotversion.version)
            this.formData.append("hardwareNo",this.updateRobotversion.hardwareNo)
            this.formData.append("remake",this.updateRobotversion.remake)
            let config = {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
            };
            
            if(this.updateLoadFlag){
                this.dialogProgressVisible=true;
            }
           
            let that=this
            this.$http.post('/robotVersion/updateRobotVersion',this.formData, config)
                .then(response => {
                                if (response.data.code === 200) {
                                    that.$message.success(response.data.message);
                                    this.updateRobotversionVisible = false
                                    clearInterval(that.timer);
                                    that.searchRobotversion()
                                    that.dialogProgressVisible=false;
                                    
                                }else{
                                    clearInterval(that.timer);
                                    that.dialogProgressVisible=false;
                                    return this.$message.error(response.data.message);
                                }
                    }).catch(failResponse => {
                })
            this.timer = setInterval(() => {
            that.$http.get('/robotVersion/uploadStatus').then(response => {
                that.percentage=response.data;  
                if(that.percentage==100){
                        clearInterval(that.timer);
                }
            })      
            }, 2000);
            this.formData=new FormData();
        },
        updaterobotversionClose(){
                this.updateRobotversion.version='';
                this.updateRobotversion.hardwareNo='';
                this.updateRobotversion.remake='';
                this.updateLoadFlag=false
                var obj = document.getElementById('upfileupload') ;
                obj.value='';
        },
        showEditDialog(val){
            this.$http.get('/robotVersion/getRobotVersionInfoById',{params :{ id :  val}})
            .then(response => {
                    if (response.data.code === 200) {
                        this.updateRobotversionVisible=true
                        this.updateRobotversion=response.data.result
                        console.log(this.updateRobotversion)
                        
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
            
        },
        robotversionClose(){
                this.$refs.addRobotversionRef.resetFields();
                this.addRobotversion.version='';
                this.addRobotversion.hardwareNo='';
                this.addRobotversion.remake='';
                var obj = document.getElementById('fileupload') ;
                obj.value='';
        },
        //根据id删除
        async deleteById(id){
            //弹框询问
            const confirmRes= await this.$confirm('此操作将永久删除, 是否继续?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err =>{
                return err
            })
            if(confirmRes !=='confirm'){
                return this.$message.info('已经取消删除')
            }
            this.$http.get('/robotVersion/deleteRobotVersion',{params :{ id :  id }})
            .then(response => {
                    if (response.data.code === 200) {
                    
                        this.$message.success("删除成功!");
                        this.searchRobotversion()
                    }else{
                        return this.$message.error(response.data.msg);
                    }
                }).catch(failResponse => {

            })
        },
        addRobotversionDialog(){
            
            this.addRobotversionVisible=true;
        },
        getFile(event, file,val) {
            var name=event.target.files[0].name
            let fileIndex = name.lastIndexOf('.')
            //获取文件格式
            let filetype = name.substr(fileIndex)
            if(filetype !== '.zip' ){
                 if("add"===val){
                    var obj=document.getElementById('fileupload');
                    obj.outerHTML=obj.outerHTML;
            }else{
                    var obj=document.getElementById('upfileupload');
                    obj.outerHTML=obj.outerHTML;
            }
                return this.$message.error('请选择zip格式的压缩包!')
            }
            if("add"!==val){
                   this.updateLoadFlag=true;
            }
            this.formData.append("file", event.target.files[0]);
            name =name.replaceAll('.zip','');
            if("add"===val){
                this.addRobotversion.version=name;
            }else{
                this.updateRobotversion.version=name;
            }
            this.formData.append("version",name)
            console.log(this.formData)
        },
        addRobotversionData(){
            if(this.addRobotversion.version==undefined || this.addRobotversion.version===""){
                  return this.$message.error('版本号为空!')
            }
            if(this.addRobotversion.hardwareNo==undefined || this.addRobotversion.hardwareNo===""){
                  return this.$message.error('硬件编号为空!')
            }
            if(this.addRobotversion.remake==undefined || this.addRobotversion.remake===""){
                  return this.$message.error('备注信息为空!')
            }
            // console.log(this.formData)
            // if(this.formData.file===undefined){
            //       return this.$message.error('请选择要上传的文件!')
            // }
            //this.formData.append("version",this.addRobotversion.version)
            this.formData.append("hardwareNo",this.addRobotversion.hardwareNo)
            this.formData.append("remake",this.addRobotversion.remake)
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            this.dialogProgressVisible=true;
            let that=this
            this.$http.post('/robotVersion/addRobotVersion',this.formData, config)
            .then(response => {
                    if (response.data.code === 200) {
                        that.$message.success(response.data.message);
                        clearInterval(that.timer);
                        that.searchRobotversion()
                        that.dialogProgressVisible=false;
                    }else{
                        clearInterval(that.timer);
                        that.dialogProgressVisible=false;
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
            this.addRobotversionVisible = false
            this.timer = setInterval(() => {
                that.$http.get('/robotVersion/uploadStatus').then(response => {
                    that.percentage=response.data;  
                    if(that.percentage==100){
                        clearInterval(that.timer);
                    }
                })      
            }, 500);
            this.formData=new FormData();
        },
        //点击指定页码跳转
        handleCurrentChange(page){
            this.robotversion.num=page;
            this.searchRobotversion()
        },
        clearParams(){
          this.robotversion.version='';
          this.robotversion.hardwareNo='';
        },
        //查询日志
        searchRobotversion(){
            var zF = /[`~!@#$%^&*()\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘'，。、]/
            if(zF.test(this.robotversion.version)||zF.test(this.robotversion.hardwareNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.$http.post('/robotVersion/selectRobotVersions',JSON.stringify(this.robotversion))
            .then(response => {
                    if (response.data.code === 200) {
                       this.robotversionList=response.data.result.data;
                       this.total=response.data.result.total;
                       this.hardwareNoLists=response.data.result.hardwareNoLists;
                       console.log("hardwareNo"+this.hardwareNo)
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
        
      
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
/deep/  .el-form-item__label {
  font-size: 18px;
  font-weight: 800;
}
</style>


// WEBPACK FOOTER //
// src/components/robot/Robotversion.vue